import React from 'react';
import Modal from '../../components/modal/modal';
import Textarea from "../UI/Textarea/Textarea";
import Input from "../UI/Input/Input";
import Select from "../UI/Select/Select";
import {apiHost} from "../../common/config";
import FeedbackModal from "./feedback-modal";

class FeedbackModalExt extends FeedbackModal {

    // Гостевая форма: поддержка отвечает на почту из обращения, поэтому все
    // поля обязательны — без ФИО и корректного email ответить некому.
    validationRules = {
        name: {require: true, title: 'ФИО'},
        email: {require: true, title: 'Электронная почта', email: true},
        message: {require: true, title: 'Сообщение'}
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            filledEmail: '',
            filledName: ''
        };
    }

    checkSendButton(event) {
        super.checkSendButton(event);
        switch (event.target.name) {
            case 'email':
                this.setState({filledEmail: event.target.value}, this.fillSubmitButtonFunc);
                break;
            case 'name':
                this.setState({filledName: event.target.value}, this.fillSubmitButtonFunc);
                break;
            default:
                break;
        }
    }

    submitFunc = () => {
        const formData = new FormData();
        const subject = this.state.selectedSubject.value;

        formData.append('subjectCode', subject);
        formData.append('message', this.state.filledMessage.trim());
        formData.append('email', this.state.filledEmail.trim());
        formData.append('name', this.state.filledName.trim());

        this.validateForm(formData);
    }

    fillSubmitButtonFunc() {
        if (this.state.filledMessage.trim() !== ''
            && this.state.filledEmail.trim() !== ''
            && this.state.filledName.trim() !== ''
        ) {
            this.setState({submitButtonFunc: this.submitFunc})
        } else {
            this.setState({submitButtonFunc: false})
        }
    }

    handleChangeSubject(selectedOption) {
        this.setState({selectedSubject: selectedOption});
    }

    render() {
        const {showForm} = this.state;

        return (
            <>
                <div className="flex justify-center mb-6">
                    <button className="text-center text-sm underline opacity-50 hover:opacity-100"
                            onClick={(event) => this.showModal(event)}>
                        <span>Обратная связь</span>
                    </button>
                </div>

                <Modal isOpen={this.state.feedbackModalOpen} onClose={this.closeModal} title="Обратная связь"
                       onSubmit={this.state.submitButtonFunc} hideCloseButton={!this.state.showButtonClose}>
                    { showForm ?
                        <>
                        <Input placeholder="Ваше ФИО" name="name" id="feedbackName"
                               onInput={(e) => this.checkSendButton(e)}
                               errors={this.state.errors}/>
                        <Input placeholder="Ваш Email" name="email" id="feedbackEmail"
                               onInput={(e) => this.checkSendButton(e)}
                               errors={this.state.errors}/>
                        <Select
                            name="subject"
                            label="Тема обращения"
                            options={this.state.subjects}
                            value={this.state.selectedSubject}
                            className="w-full"
                            onChange={(selectedOption) => this.handleChangeSubject(selectedOption)}
                        />
                        <Textarea
                            placeholder="Сообщение"
                            rows="5"
                            name="message"
                            id="feedbackMessage"
                            onInput={(e) => this.checkSendButton(e)}
                            errors={this.state.errors}
                        />
                        </>
                        : this.renderConfirmation()
                    }
                </Modal>
            </>
        );
    }
}

export default FeedbackModalExt;
